$(document).ready(function () {
  // Collection Description Js
  /*
  $('.ctm_data_collection a.itg_show_data .showmore_data').on( "click", function(){
    $('.ctm_data_collection').addClass('show_more_text');
    $('.showmore_data').hide();
    $('.showless_data').show();
  });
  $('.ctm_data_collection a.itg_show_data .showless_data').on( "click", function(){
    $('.ctm_data_collection').removeClass('show_more_text');
    $('.showless_data').hide();
    $('.showmore_data').show();
  });
  */

  //FAQ Scroll Js
  $("a.faq_redirect_btn").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#meta_faq").offset().top - 200,
      },
      1000
    );
  });

  //Video Scroll Js
  $("a.ctm_video_redirect").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".collection_ctm_video").offset().top - 150,
      },
      1000
    );
  });

  $("span.prod_faq_show").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#meta_faq").offset().top - 200,
      },
      1000
    );
  });

  // Form Scroll js
  $(".ctm_form_redirect").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".form_action_data ").offset().top - 150,
      },
      1000
    );
  });

  // accordion js
  $(".acodn_contn").hide();
  $(".acodn_que").click(function () {
    $(".acodn_que span").css("transform", "rotate(0deg)");
    if ($(".acodn_contn").is(":visible")) {
      $(".acodn_contn").slideUp(300);
    }
    if ($(this).next(".acodn_contn").is(":visible")) {
      $(this).next(".acodn_contn").slideUp(300);
      $(this)
        .closest(".accept_tb")
        .find(".acodn_que span")
        .css("transform", "rotate(0deg)");
    } else {
      $(this).next(".acodn_contn").slideDown(300);
      $(this)
        .closest(".accept_tb")
        .find(".acodn_que span")
        .css("transform", "rotate(180deg)");
    }
  });

  //Description Js
  $(".read-more a").click(function (event) {
    event.preventDefault();
    $(".description-text").toggleClass("expanded");
    if ($(".description-text").hasClass("expanded")) {
      $(".description-text").css({
        height: "auto",
        overflow: "visible",
        "-webkit-line-clamp": "130",
      });
      $(".read-more a").text("Read Less");
    } else {
      $(".description-text").css({
        height:
          "400px" /* adjust this value to match the number of lines set in the CSS */,
        overflow: "hidden",
      });
      $(".read-more a").text("Read More");
      $("html, body").animate(
        { scrollTop: $(".ctm_meta_description").offset().top - 200 },
        "slow"
      );
    }
  });

  $(document).on("click", ".ctm_afirm_main", function () {
    $(document).find(".affirm-modal-trigger").trigger("click");
  });
});

$(document).ready(function () {
  $(".facility_contact_popup a").on("click", function () {
    $(".custom_detail_popup_main").show();
  });
  $(".close_detail_popup").on("click", function () {
    $(".custom_detail_popup_main").hide();
  });

  // Fleet Form Popup Js
  $(".close_kl_popup").click(function () {
    $(".kl_main_pop").hide();
    var url = window.location.href;
    var finlurl = url + "?success";
    window.location.assign(finlurl);
  });
});

// Copy text js
function copy() {
  let copyText = document.getElementById("copyClipboard");
  let copySuccess = document.getElementById("copied-success");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);

  copySuccess.style.opacity = "1";
  setTimeout(function () {
    copySuccess.style.opacity = "0";
  }, 4000);
}

window.addEventListener("load", updateHeaderHeight);
window.addEventListener("resize", updateHeaderHeight);

function updateHeaderHeight() {
  let totalHeaderHeight =
    document.querySelector(".brator-header-area.header-one")?.offsetHeight || 0;

  let totalSubheaderHeight =
    document.querySelector(".brator-header-menu-area")?.offsetHeight || 0;

  document.documentElement.style.setProperty(
    "--total-header-height",
    `${totalHeaderHeight}px`
  );

  document.documentElement.style.setProperty(
    "--total-subheader-height",
    `${totalSubheaderHeight}px`
  );
}

window.addEventListener("DOMContentLoaded", () => {
  const headerElement = document.querySelector(".brator-header-area.header-one");

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        if (headerElement.classList.contains("open")) {
          document.body.classList.add("top-padding");
        } else {
          document.body.classList.remove("top-padding");
        }
      }
    });
  });

  if (headerElement) {
    observer.observe(headerElement, { attributes: true });
  }

  const footerTextElements = document.querySelectorAll('.brator-footer-area-main .custom-block-text p');

  footerTextElements.forEach(footerTextElement => {
    if (footerTextElement && footerTextElement.textContent.trim() === '832-977-7261') {
      footerTextElement.parentElement.innerHTML = '<a href="sms:832-977-7261">832-977-7261</a>';
    }
  });
});

window.addEventListener("load", () => {
  const yotpoButton = document.querySelector('.template-handle-product .yotpo-sr-bottom-line-button');

  if (yotpoButton) {
    yotpoButton.addEventListener('click', () => {
      const reviewTab = document.querySelector('.pro_tab_review_list.js-tabs__title');

      if (reviewTab) {
        reviewTab.click();
      }

      const yotpoWidget = document.querySelector('.js-tabs__content .yotpo-widget-instance');

      if (yotpoWidget) {
        const totalHeaderHeight =
          document.querySelector(".brator-header-area.header-one")?.offsetHeight || 0;

        const totalSubheaderHeight =
          document.querySelector(".brator-header-menu-area")?.offsetHeight || 0;

        const offset = totalHeaderHeight + totalSubheaderHeight;

        const widgetTopPosition = yotpoWidget.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: widgetTopPosition - offset,
          behavior: 'smooth'
        });
      }
    });
  }
});